"use client";

import React, { createContext, useContext } from "react";
import type { LayoutData } from "@/lib/fetchLayoutData";

const LayoutDataContext = createContext<LayoutData | null>(null);

export function LayoutDataProvider({
  value,
  children,
}: {
  value: LayoutData;
  children: React.ReactNode;
}) {
  return (
    <LayoutDataContext.Provider value={value}>
      {children}
    </LayoutDataContext.Provider>
  );
}

export function useLayoutData() {
  const ctx = useContext(LayoutDataContext);
  if (!ctx) throw new Error("useLayoutData must be used within LayoutDataProvider");
  return ctx;
}
